import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, { type EditInCanvasOpenedAction } from './useTrackEditInCanvasOpened.meta';

export type UseTrackEditInCanvasOpenedParams = {
  opened_from:
    | 'action_bar'
    | 'action_bar_export_as'
    | 'announcement'
    | 'asset_card_hover'
    | 'asset_context_menu'
    | 'asset_modal_export_as'
    | 'asset_modal_header_menu'
    | 'asset_modal_quick_tools'
    | 'asset_modal_versions_menu'
    | 'asset_modal_video_editor'
    | 'gallery_item_context_menu'
    | 'gallery_item_ellipsis_menu'
    | 'gallery_item_export_as'
    | 'gallery_multi_select_context_menu'
    | 'gallery_multi_select_ellipsis_menu'
    | 'gallery_multi_select_export_as'
    | 'table_item_context_menu'
    | 'table_item_ellipsis_menu'
    | 'table_item_export_as'
    | 'table_multi_select_context_menu'
    | 'table_multi_select_ellipsis_menu'
    | 'table_multi_select_export_as';
  action: EditInCanvasOpenedAction;
  clip_count: number;
  board_id?: string;
  size_set_eligible?: boolean;
  size_set_offered?: boolean;
  size_set_id?: string;
  size_set_format_count?: number;
};

export const useTrackEditInCanvasOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackEditInCanvasOpened = useCallback(
    (params: UseTrackEditInCanvasOpenedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackEditInCanvasOpened };
};
